'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EventHeaderDirective;

var _eventHeaderLcEventTpl = require('./event-header-lc-event.tpl.html');

var _eventHeaderLcEventTpl2 = _interopRequireDefault(_eventHeaderLcEventTpl);

var _eventHeaderStatsTpl = require('./event-header-stats.tpl.html');

var _eventHeaderStatsTpl2 = _interopRequireDefault(_eventHeaderStatsTpl);

var _eventHeaderErrorTpl = require('./event-header-error.tpl.html');

var _eventHeaderErrorTpl2 = _interopRequireDefault(_eventHeaderErrorTpl);

var _eventHeaderDebugRulenodeTpl = require('./event-header-debug-rulenode.tpl.html');

var _eventHeaderDebugRulenodeTpl2 = _interopRequireDefault(_eventHeaderDebugRulenodeTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

function EventHeaderDirective($compile, $templateCache, types) {

    var linker = function linker(scope, element, attrs) {

        var getTemplate = function getTemplate(eventType) {
            var template = '';
            switch (eventType) {
                case types.eventType.lcEvent.value:
                    template = _eventHeaderLcEventTpl2.default;
                    break;
                case types.eventType.stats.value:
                    template = _eventHeaderStatsTpl2.default;
                    break;
                case types.eventType.error.value:
                    template = _eventHeaderErrorTpl2.default;
                    break;
                case types.debugEventType.debugRuleNode.value:
                    template = _eventHeaderDebugRulenodeTpl2.default;
                    break;
                case types.debugEventType.debugRuleChain.value:
                    template = _eventHeaderDebugRulenodeTpl2.default;
                    break;
            }
            return $templateCache.get(template);
        };

        scope.loadTemplate = function () {
            element.html(getTemplate(attrs.eventType));
            $compile(element.contents())(scope);
        };

        attrs.$observe('eventType', function () {
            scope.loadTemplate();
        });
    };

    return {
        restrict: "A",
        replace: false,
        link: linker,
        scope: false
    };
}


// WEBPACK FOOTER //
// ./src/app/event/event-header.directive.js